import { useCallback, useState } from 'react';
import { useRestClient } from '../../../core/api/RestClientContext';
import { ChatDto, ChatStatus } from '../models/support';

interface UseSupportActionsResult {
    sendMessage: (tgId: string, text: string, file: File | null, onSuccess: (updated: ChatDto) => void) => Promise<void>;
    changeStatus: (tgId: string, status: ChatStatus, onSuccess: (updated: ChatDto) => void) => Promise<void>;
    sending: boolean;
}

export function useSupportActions(): UseSupportActionsResult {
    const client = useRestClient();
    const [sending, setSending] = useState(false);

    const sendMessage = useCallback(async (
        tgId: string,
        text: string,
        file: File | null,
        onSuccess: (updated: ChatDto) => void,
    ) => {
        setSending(true);
        try {
            const formData = new FormData();
            if (text) formData.append('text', text);
            if (file) formData.append('file', file);
            const updated = await client.postForm<ChatDto>(
                `/support/chats/${tgId}/messages`,
                formData,
            );
            onSuccess(updated);
        } finally {
            setSending(false);
        }
    }, [client]);

    const changeStatus = useCallback(async (
        tgId: string,
        status: ChatStatus,
        onSuccess: (updated: ChatDto) => void,
    ) => {
        setSending(true);
        try {
            const updated = await client.patch<ChatDto>(
                `/support/chats/${tgId}/status`,
                { status },
            );
            onSuccess(updated);
        } finally {
            setSending(false);
        }
    }, [client]);

    return { sendMessage, changeStatus, sending };
}
